export default {
   
    usuaDepe: {
        estado: true
    }
}